export default __webpack_public_path__ + "static/media/logomcapn.12aa69fa.png";